import React from "react";
import styles from "./ServicesPage.module.css";
import Cards from "./Cards/Cards";
import one from "assets/icons/machinelearningicon.svg";
import two from "assets/icons/uxicon.svg";
import three from "assets/icons/blockchainicon.svg";
import four from "assets/icons/dataanalyicon.svg";
import five from "assets/icons/webdevelopment.svg";
import six from "assets/icons/interneticon.svg";

const ServicePage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <span className={styles.tag}>What We Do</span>
        <h1 className={styles.mainHead}>
          Our <span className={styles.addC}>Development</span> Services
        </h1>
        <p className={styles.paragraph}>
          We deliver enterprise-grade solutions spanning AI, cloud, web, and IoT — combining innovation with rigorous engineering standards.
        </p>
      </div>
      <div className={styles.cards}>
        <div className={styles.cardContainers}>
          <Cards
            imageSrc={one}
            altText="Machine Learning Solutions"
            heading="Machine Learning Solutions"
            paragraph="Innovation-driven AI & ML solutions — automating workflows and unlocking insights at scale."
          />
          <div className={styles.customCard}>
            <Cards
              imageSrc={two}
              altText="UI & UX Designing"
              heading="UI & UX Designing"
              paragraph="Creating customized interactive user interfaces with deep graphic knowledge and brand values."
            />
          </div>
          <Cards
            imageSrc={three}
            altText="Blockchain"
            heading="Blockchain"
            paragraph="Custom blockchain solutions for startups and enterprises — decentralized, secure, and scalable."
          />
        </div>
        <div className={styles.cardContainers}>
          <Cards
            imageSrc={four}
            altText="BI & Data Analytics"
            heading="BI & Data Analytics"
            paragraph="Finding new growth opportunities by transforming raw data into actionable intelligence."
          />
          <div className={styles.customCard}>
            <Cards
              imageSrc={five}
              altText="Web & Mobile Development"
              heading="Web & Mobile Development"
              paragraph="Scalable web and mobile applications delivering faster, measurable, and efficient results."
            />
          </div>
          <Cards
            imageSrc={six}
            altText="Internet of Things"
            heading="Internet of Things"
            paragraph="Trusted IoT consultancy driving productivity and connected intelligence for your business."
          />
        </div>
      </div>
    </div>
  );
};

export default ServicePage;
